export function serviceTarget(search) {
  const params = new URLSearchParams(search);
  const nodeId = params.get('nodeId') || '';
  const service = params.get('service') || '';
  const valid = /^[a-z0-9][a-z0-9-]{0,127}$/;
  if (!valid.test(nodeId) || !valid.test(service)) throw new Error('Invalid device service request.');
  return { nodeId, service };
}

export async function requestServiceAccess({ config, token, target, signal, fetchImpl = fetch }) {
  if (!token) throw new Error('Your session has expired. Sign in again.');
  const query = new URLSearchParams({ ...target, session: `${target.nodeId}-${target.service}`, probe: 'true' });
  const response = await fetchImpl(`${config.aws.apiEndpoint}/demo-token?${query}`, {
    headers: { Authorization: token }, signal, cache: 'no-store'
  });
  if (!response.ok) {
    if (response.status === 403) throw new Error('You do not have access to this device service. Ask its owner to invite you.');
    if (response.status === 401) throw new Error('Your session has expired. Sign in again.');
    if (response.status === 404) throw new Error('This device service is not available.');
    if (response.status === 409) throw new Error('This device service is offline or still starting. Try again shortly.');
    throw new Error(`Service access failed (${response.status}).`);
  }
  const result = await response.json();
  if (result.routeStatus !== 'NAVIGABLE') throw new Error('This device service is still starting. Try again shortly.');
  let url;
  try { url = new URL(result.demoUrl); } catch { throw new Error('Invalid service launch response.'); }
  const suffix = config.frp?.wildcardDemoDomain?.replace(/^\*\./, '');
  const expectedHost = `${target.nodeId}-${target.service}.${suffix}`;
  if (!suffix || url.protocol !== 'https:' || url.hostname !== expectedHost || url.username || url.password || url.port) {
    throw new Error('The service launch address did not match the requested device.');
  }
  return url.href;
}
